export default __webpack_public_path__ + "static/media/GalanoGrotesqueLight.ae60a1ea.woff2";